<template>
  <FormSelect
    :disabled="disabled"
    :loading="loading"
    :name="$t('meta.site')"
    :options="siteOptions"
    :required="required"
    :value="value"
    @input="emitInput"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import sitesApi from '@/api/sites'

export default {
  components: { FormSelect },
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    companyUuid: { type: String, required: true },
  },
  data: () => ({
    sites: null,
    loading: true,
  }),
  computed: {
    siteOptions() {
      return this.sites?.map(site => ({
        label: `${site.name} (${site.company.name})`,
        value: site.uuid,
      }))
    },
  },
  methods: {
    emitInput(siteUuid) {
      const site = this.sites?.find(site => site.uuid === siteUuid)

      this.$emit('input', site?.uuid)
    },
  },
  async mounted() {
    this.sites = (await sitesApi.getAll({ projects: true, company_uuid: this.companyUuid })).sites
    this.loading = false
  },
}
</script>
